import ColumnAndItemSummaryLayout from "./ColumnAndItemSummaryLayout";
import InstoreDetailsForm from "./InstoreDetailsForm";
import HeadingMain from "./HeadingMain";
import React from "react";
import { useAppContext } from "./AppContext";
import { useTakebackConfig } from "./TakebackConfigContext";

function InstoreAddDetails() {
  const { takebackItems, donatedTakebackItems } = useAppContext();
  const { showSteps } = useTakebackConfig();

  return (
    <ColumnAndItemSummaryLayout
      itemsEditable={true}
      items={takebackItems}
      donations={donatedTakebackItems}
      showSummary={showSteps}
      columnContent={
        <>
          <HeadingMain pb={[40, 40, 80, 80]}>
            We just need a few details to complete your takeback
          </HeadingMain>
          <InstoreDetailsForm />
        </>
      }
    />
  );
}

export default InstoreAddDetails;
